"use client";

// neutral avatar placeholder (swap by passing `avatar` with a real image src)
const Avatar = ({ src }) =>
  src ? (
    // eslint-disable-next-line @next/next/no-img-element
    <img src={src} alt="" className="h-full w-full rounded-full object-cover" />
  ) : (
    <div className="flex h-full w-full items-center justify-center rounded-full bg-gradient-to-br from-zinc-200 to-zinc-300">
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-1/2 w-1/2 text-zinc-400"
      >
        <path d="M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-5 0-9 2.5-9 6v2h18v-2c0-3.5-4-6-9-6z" />
      </svg>
    </div>
  );

// little indigo cursor/pointer triangle that sits just above an outer corner
const Cursor = ({ side }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 20 20"
    fill="none"
    className={`absolute -top-3 ${
      side === "left" ? "-right-3 rotate-90" : "-left-4 -rotate-90 scale-x-[-1]"
    }`}
  >
    <path
      d="M3 2L17 9L9.5 10.5L7.5 18L3 2Z"
      fill="#2309BA"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

// A floating "role" chip: blue rounded rectangle, an avatar overlapping the
// outer edge, and a cursor triangle at the top corner.
const RolePill = ({ label, avatar, side = "left", className = "" }) => {
  const avatarLeft = side === "left";

  return (
    <div className={`pointer-events-none absolute ${className}`}>
      <div className="relative inline-flex">
        <Cursor side={side} />

        <div
          className={`flex h-7 items-center whitespace-nowrap rounded-full bg-gradient-to-r from-[#3258E8] to-[#4872F5] text-[12px] font-medium leading-none text-white shadow-lg ${
            avatarLeft ? "pl-[40px] pr-4" : "pl-4 pr-[40px]"
          }`}
        >
          {label}
        </div>

        <div
          className={`absolute top-1/2 h-[40px] w-[40px] -translate-y-1/2 overflow-hidden rounded-full ring-[3px] ring-white shadow-md ${
            avatarLeft ? "-left-3" : "-right-3"
          }`}
        >
          <Avatar src={avatar} />
        </div>
      </div>
    </div>
  );
};

export default RolePill;
